(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["naree-product-page-actions"] && !Shopify.designMode) return;
  try {
    (function () {

  function initNareeProductPageActions() {

    const actionRows =
      document.querySelectorAll(
        '.naree-product-page-actions'
      );

    if (!actionRows.length) {
      return;
    }

    actionRows.forEach(function (actions) {

      if (actions.dataset.initialized === 'true') {
        return;
      }

      actions.dataset.initialized = 'true';


      const wishlist =
        actions.querySelector(
          '.naree-product-wishlist'
        );

      const share =
        actions.querySelector(
          '.naree-product-share'
        );

      const overlay =
        document.querySelector(
          '.naree-product-share-overlay'
        );

      const close =
        document.querySelector(
          '.naree-product-share-close'
        );

      const copyButton =
        document.querySelector(
          '.naree-product-copy-button'
        );

      const urlInput =
        document.querySelector(
          '.naree-product-copy-input'
        );

      const status =
        document.querySelector(
          '.naree-product-copy-status'
        );


      if (!wishlist || !share || !overlay) {
        return;
      }


      /* =====================================================
         PRODUCT URL
      ===================================================== */

      const productUrl =
        window.location.origin +
        window.location.pathname;


      if (urlInput) {
        urlInput.value = productUrl;
      }


      /* =====================================================
         WISHLIST
      ===================================================== */

      const productHandle =
        actions.dataset.productHandle ||
        window.location.pathname;

      const wishlistKey =
        'naree_product_wishlist_' +
        productHandle;


      if (
        localStorage.getItem(wishlistKey) === 'true'
      ) {

        wishlist.classList.add('is-active');

        wishlist.setAttribute(
          'aria-pressed',
          'true'
        );

        wishlist.setAttribute(
          'aria-label',
          'Remove from wishlist'
        );

      }


      wishlist.addEventListener(
        'click',
        function () {

          const active =
            wishlist.classList.toggle(
              'is-active'
            );


          wishlist.setAttribute(
            'aria-pressed',
            active ? 'true' : 'false'
          );


          wishlist.setAttribute(
            'aria-label',
            active
              ? 'Remove from wishlist'
              : 'Add to wishlist'
          );


          localStorage.setItem(
            wishlistKey,
            active ? 'true' : 'false'
          );

        }
      );


      /* =====================================================
         OPEN SHARE
      ===================================================== */

      share.addEventListener(
        'click',
        function () {

          overlay.classList.add(
            'is-open'
          );

          share.classList.add(
            'is-active'
          );

          share.setAttribute(
            'aria-expanded',
            'true'
          );

          overlay.setAttribute(
            'aria-hidden',
            'false'
          );

          document.body.style.overflow =
            'hidden';

        }
      );


      /* =====================================================
         CLOSE SHARE
      ===================================================== */

      function closeShare() {

        overlay.classList.remove(
          'is-open'
        );

        share.classList.remove(
          'is-active'
        );

        share.setAttribute(
          'aria-expanded',
          'false'
        );

        overlay.setAttribute(
          'aria-hidden',
          'true'
        );

        document.body.style.overflow =
          '';

      }


      if (close) {

        close.addEventListener(
          'click',
          closeShare
        );

      }


      overlay.addEventListener(
        'click',
        function (event) {

          if (
            event.target === overlay
          ) {
            closeShare();
          }

        }
      );


      document.addEventListener(
        'keydown',
        function (event) {

          if (
            event.key === 'Escape' &&
            overlay.classList.contains(
              'is-open'
            )
          ) {
            closeShare();
          }

        }
      );


      /* =====================================================
         COPY LINK
      ===================================================== */

      if (copyButton && urlInput) {

        copyButton.addEventListener(
          'click',
          async function () {

            try {

              await navigator.clipboard.writeText(
                productUrl
              );

              copyButton.textContent =
                'COPIED';

              if (status) {
                status.textContent =
                  'Product link copied.';
              }


              setTimeout(
                function () {

                  copyButton.textContent =
                    'COPY';

                  if (status) {
                    status.textContent =
                      '';
                  }

                },
                2000
              );


            } catch (error) {

              urlInput.select();

              document.execCommand(
                'copy'
              );

              if (status) {
                status.textContent =
                  'Product link copied.';
              }

            }

          }
        );

      }


      /* =====================================================
         SHARE SERVICES
      ===================================================== */

      const shareButtons =
        document.querySelectorAll(
          '[data-share-service]'
        );


      shareButtons.forEach(
        function (button) {

          button.addEventListener(
            'click',
            async function () {

              const service =
                button.dataset.shareService;

              const title =
                document.title;

              const message =
                'Check out this product from Naaree: ' +
                productUrl;


              /* WHATSAPP */

              if (
                service === 'whatsapp'
              ) {

                window.open(
                  'https://wa.me/?text=' +
                  encodeURIComponent(
                    message
                  ),
                  '_blank',
                  'noopener'
                );

                return;
              }


              /* FACEBOOK */

              if (
                service === 'facebook'
              ) {

                window.open(
                  'https://www.facebook.com/sharer/sharer.php?u=' +
                  encodeURIComponent(
                    productUrl
                  ),
                  '_blank',
                  'noopener,width=600,height=500'
                );

                return;
              }


              /* EMAIL / GMAIL */

              if (
                service === 'email'
              ) {

                window.location.href =
                  'mailto:?subject=' +
                  encodeURIComponent(
                    title
                  ) +
                  '&body=' +
                  encodeURIComponent(
                    message
                  );

                return;
              }


              /* INSTAGRAM */

              if (
                service === 'instagram'
              ) {

                if (
                  navigator.share
                ) {

                  try {

                    await navigator.share({
                      title: title,
                      text: message,
                      url: productUrl
                    });

                  } catch (error) {}

                } else {

                  try {

                    await navigator.clipboard.writeText(
                      productUrl
                    );

                  } catch (error) {}

                  if (status) {

                    status.textContent =
                      'Link copied. Paste it into Instagram.';

                  }

                }

                return;
              }


              /* MORE / NATIVE SHARE */

              if (
                service === 'native'
              ) {

                if (
                  navigator.share
                ) {

                  try {

                    await navigator.share({
                      title: title,
                      text: message,
                      url: productUrl
                    });

                  } catch (error) {}

                } else {

                  try {

                    await navigator.clipboard.writeText(
                      productUrl
                    );

                  } catch (error) {}

                  if (status) {

                    status.textContent =
                      'Product link copied.';

                  }

                }

              }

            }
          );

        }
      );

    });

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initNareeProductPageActions
    );

  } else {

    initNareeProductPageActions();

  }

})();
  } catch(e) { console.error(e); }
})();

})();
